import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, Container } from '@mui/material';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../../services/api';

/**
 * Payment entry page: customer lands here from the link in the invoice email.
 * We resolve the link (valid/cancelled/expired); if valid, redirect to Razorpay; else show SalesGro failed UI.
 */
const PaymentPay = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // 'loading' | 'redirect' | 'failed'

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (!ref) {
      navigate('/payment/failed?reason=not_found', { replace: true });
      return;
    }

    let cancelled = false;
    api
      .get('/billing/payment-link/', { params: { ref } })
      .then((res) => {
        if (cancelled) return;
        const { valid, payment_url, reason } = res.data || {};
        if (valid && payment_url) {
          setStatus('redirect');
          window.location.href = payment_url;
          return;
        }
        navigate(`/payment/failed?reason=${reason || 'not_found'}`, { replace: true });
      })
      .catch(() => {
        if (!cancelled) {
          navigate('/payment/failed?reason=not_found', { replace: true });
        }
      });

    return () => { cancelled = true; };
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: '#f3f6fb',
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <CircularProgress size={48} sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          {status === 'redirect' ? 'Taking you to secure payment...' : 'Checking payment link...'}
        </Typography>
      </Container>
    </Box>
  );
};

export default PaymentPay;
